/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import '@webcomponents/webcomponentsjs'

const lui = window.lui = window.lui || {}
lui.usePolyfills = !!navigator.userAgent.match(/Firefox\/([1-5]\d|6[012])\.|Edge\/\d/)

lui.applyCssPolyfill = (css, component) => {
  if (lui.usePolyfills && component) {
    css = css.replace(/(:host(\(([^)]+?)\))? (::slotted\(([^)]+?)\)))(,|\{)/g, `${component.constructor.is}$3 $5$6`)
    css = css.replace(/(:host(\((.+?)\))?( .+?)?)(,|\{)/g, `${component.constructor.is}$3$4$5`)
    css = css.replace(/(::slotted\((.+?)\))(,|\{)/g, `${component.constructor.is} $2$3`)
  }
  if (navigator.userAgent.match(/Firefox\/\d/)) {
    css = css.replace(/@media ?\(hover: ?hover\)/g, `@media all`)
  }
  return css
}

// Fix for infinite loop in Angular
// https://saeljira.it.here.com/browse/LUI-1153
// https://github.com/angular/angular/issues/31712
lui.createMutationObserver = (...args) => {
  const unwrappedObserver = window.Zone && window.Zone.__symbol__ && window[window.Zone.__symbol__('MutationObserver')]
  return new (unwrappedObserver || window.MutationObserver)(...args)
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-polyfill/index.js
// module id = 140
// module chunks = 0 1 39 40